module.exports = __webpack_public_path__ + "media/dashboard/assets/images/file-link-ad3b4d105332bda8bda957096832feae.svg";